import React, { PureComponent } from 'react'
import classnames from 'classnames'
import {
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col
} from 'reactstrap'

import TableNews from '../../../molecules/TableNews'
import TablePublications from '../../../molecules/TablePublications'

const addNewsOnClick = history => history.push('/admin/noticias')
const addPublicationsOnClick = history => history.push('/admin/publicacoes')

class Main extends PureComponent {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: 'news'
    }
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render () {
    const { history, news, publications, deleteNews, deletePublication } = this.props

    return (
      <div>
        <Nav tabs className='justify-content-center'>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === 'news' })}
              onClick={() => { this.toggle('news') }}
            >
              Notícias
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === 'publications' })}
              onClick={() => { this.toggle('publications') }}
            >
              Publicações
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId='news'>
            <Row className='d-flex justify-content-end mt-4 mb-4 mr-1'>
              <Button color='primary' onClick={() => addNewsOnClick(history)}>
                Criar nova notícia
              </Button>
            </Row>
            <Row>
              <Col sm='12'>
                <TableNews remove={deleteNews} news={news} />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='publications'>
            <Row className='d-flex justify-content-end mt-4 mb-4 mr-1'>
              <Button color='primary' onClick={() => addPublicationsOnClick(history)}>
                Criar nova publicação
              </Button>
            </Row>
            <Row>
              <Col sm='12'>
                <TablePublications remove={deletePublication} publications={publications} />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/templates/Admin/Main/Main.js